import type { ContentBlock, SectionBlock } from 'types/content-editor'
export type BlockConfig = {
  type: SectionBlock | ContentBlock
  svg?: any
  text: string
  imageClass?: string
  textClass?: string
}
const commonBlocks: BlockConfig[] = [
  {
    type: 'tracklist',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/tracklist.svg'),
    text: 'Playlist',
    textClass: 'editor-block-list__block__text--small',
  },
  {
    type: 'button',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/btn.svg'),
    text: 'Button', // imageClass: 'editor-block-list__block__image--small',
  },
  {
    type: 'divider',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/divider.svg'),
    text: 'Divider',
  },
  {
    type: 'text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/text.svg'),
    text: 'Text',
  },
  {
    type: 'image',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/image.svg'),
    text: 'Image',
  },
]
const imageAndTextBlock: BlockConfig = {
  type: 'image-and-text',
  svg: require('!svg-inline!assets/images/campaign-editor-v2/image-text.svg'),
  text: 'Text & image',
}
export const sectionBlocks: (BlockConfig | null | undefined)[] = [
  ...commonBlocks,
  imageAndTextBlock,
  {
    type: 'two-column-text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/two-column-text.svg'),
    text: 'Two column text',
  },
  {
    type: 'two-column-image',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/two-column-image.svg'),
    text: 'Two column image',
  },
  {
    type: 'two-column-text-image',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/two-column-text-image.svg'),
    text: 'Two column text/image (right)',
  },
  {
    type: 'two-column-image-text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/two-column-image-text.svg'),
    text: 'Two column text/image (left)',
  },
  {
    type: 'two-column-image-and-text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/two-column-image+text.svg'),
    text: 'Two column text & image',
  },
  {
    type: 'three-column-text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/three-column-text.svg'),
    text: 'Three column text',
  },
  {
    type: 'three-column-image',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/three-column-image.svg'),
    text: 'Three column image',
  },
  {
    type: 'three-column-image-and-text',
    svg: require('!svg-inline!assets/images/campaign-editor-v2/three-column-image+text.svg'),
    text: 'Three column text & image',
  }, // {
  //   type: 'two-column-tracklist',
  //   svg: require('!svg-inline!assets/images/campaign-editor-v2/tracklist.svg'),
  //   text: 'Two column playlist',
  // },
]
export const contentBlocks: (BlockConfig | null | undefined)[] = [
  imageAndTextBlock,
  ...commonBlocks,
]
